import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';

import { config } from '../../../config/config';
import { useDemographicsFilter } from '../../shared/hooks/demographic';
import { useUserCurrencies } from '../../shared/hooks/use-user-currencies';
import { selectLocale } from '../../shared/store/locale.store';
import { exists } from '../../shared/utils/filters';
import { Footer as FooterComponent } from '../components/footer/footer';
import { useGetFooterCollectionsQuery } from '../queries/footer.graphql';

export interface IFooterProps {
    className?: string | undefined;
}

export const Footer: FunctionComponent<IFooterProps> = ({ className }) => {
    const { user } = useAuth();
    const { currencies } = useUserCurrencies();
    const availableCurrencies = useMemo(
        () => (user ? currencies : config.DEFAULT_CURRENCIES) ?? [],
        [currencies, user],
    );

    const locale = useSelector(selectLocale);

    const [{ data: footerData }] = useGetFooterCollectionsQuery({
        variables: {
            xTenantID: config.TENANT_ID,
            locale: locale,
            skinId: config.SKIN_ID,
        },
    });
    const footerList = (footerData?.getFooterCollections || []).filter(exists);
    const filteredFooterList = useDemographicsFilter(footerList);

    return (
        <>
            {/*<BannerCollection page="live-casino" type="lobby"></BannerCollection>*/}
            <FooterComponent
                className={className}
                currencies={availableCurrencies}
                footerData={filteredFooterList}
            />
        </>
    );
};
